/// <reference types="fine-uploader/typescript/fine-uploader" />
import { Component, OnInit, ViewChild, OnDestroy, ApplicationRef, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, NgForm, AbstractControl, NgModel } from '@angular/forms';
import { stringify } from 'json-stringify-safe';
import { Router } from '@angular/router';
//import { FileInfo, UploadEvent, RemoveEvent } from '@progress/kendo-angular-upload';
//import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';

import {
  FineUploaderBasic, CoreOptions, ChunkingOptions, CorsOptions, RequestOptions
  , CoreEvents, OnComplete, ChunkData, ParamNamesOptions
} from 'fine-uploader/lib/core';
import { PrettyJsonModule } from 'angular2-prettyjson';
import { Subscription, Subject, Observable } from 'rxjs';
import { delay } from 'rxjs/operators'
import { State } from '@progress/kendo-data-query';
import { DateTime } from 'typescript-dotnet-es6/System/Time/DateTime';
import { Dictionary } from 'typescript-dotnet-es6/System/Collections/Dictionaries/Dictionary';
import { ExcelImportService, CustomersService, DefaultsService, UpdateStateService, RaService, UserProfileService, CustomerModel } from '../../../core';
import { RateAuditSettingsService } from '../../../core/rate-audit-settings.service';

import { AuditStdImport, ImportResults, Property } from './utilities/auditstd-import-model';
import { AuditStdEdit } from './utilities/auditstd-edit-model';
import { qaRerunHeader, qaPropertiesHeader} from '../../../core/models/qa-properties-model';
import { AuditStd_DateRangeRules, defaultAuditStd_DateRangeRules } from '../../../core/models/rate-audit-settings-model';
import { CorporateDateRules } from './utilities/corporateDateRules';

import { AlertComponent, EnumAlertType } from '../../../common/component/alert/alert.component';
import { environment } from '../../../../environments/environment';
import { PropertyEditComponent } from './property-edit/property-edit.component';
import { ProcessSettingsComponent } from './process-settings/process-settings.component';
import { QaSelectCompanyComponent } from '../ra-create/qa-select-company/qa-select-company.component'
import { QaEmailVerificationComponent } from '../ra-create/qa-email-verification/qa-email-verification.component'
import { KeywordManager } from '../../../core/keyword-manager';
import { Route } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { getPropertiesQAI_Supply_HyattDomestic_746_2019_AdobeSystems } from './utilities/import-sample';
import { RvService } from '../../../core';
import { GDSCredentials } from '../../../core/models/gds-credentials-model';
@Component({
  selector: 'app-ra-create',
  templateUrl: './ra-create.component.html',
  styleUrls: ['./ra-create.component.scss']
})
export class RaCreateComponent implements OnInit, OnDestroy {
  quickAuditRerunID: any = null;
  propertyCount: number;
  propertyCountDescription: string = "";
  gdsCredentials: GDSCredentials = new GDSCredentials();
  disableAuditAmadeus: boolean = false;
  disableAuditApollo: boolean = false;
  disableAuditGalileo: boolean = false;
  disableAuditSabre: boolean = false;
  disableAuditWorldspan: boolean = false;
  amadeusAvailable: boolean = true;
  apolloAvailable: boolean = true;
  galileoAvailable: boolean = true;
  sabreAvailable: boolean = true;
  worldspanAvailable: boolean = true;
  showGds:boolean=false;

  constructor(
    private excelImportService: ExcelImportService
    , private customersService: CustomersService
    , private rateAuditSettingsService: RateAuditSettingsService
    , private defaultsService: DefaultsService
    , private updateStateService: UpdateStateService<boolean>
    , private application: ApplicationRef
    , private raService: RaService
    , private router: Router
    , private route: ActivatedRoute
    , private userProfileService: UserProfileService
    , private rvService: RvService

  ) {
    this.domainStr = environment.baseWebApiUrl;
  }
  ngOnInit() {
    this.propertyCountDescription = "";
    this.propertyCount = null;
    this.editedAudit = new AuditStdEdit(new AuditStdImport(),false,"");
    this.route.data.subscribe((d) => {
      this.isQuickAudit = d.QuickAudit;
      if (this.isQuickAudit) {
        this.showGds=true;
        this.checkGDSCredentials();
        let snapshot = this.route.snapshot;
        this.quickAuditRerunID =snapshot.params.rerunID;
        if(this.quickAuditRerunID){
          this.isQuickAuditRerun = true;
          //setup event
          var rerunEvent = new EventEmitter<void>();
          rerunEvent.pipe(delay(500)).subscribe( () => this.triggerStepChange.next());
          rerunEvent.next();
        }

      } else {
        this.selectFileControl = this.fileItem ? this.fileItem.control : undefined;
        this.setupFineUploader();
      }
    });
    let s1 = this.updateStateService.watchState
      .subscribe(s => {
        this.isBusy(s);
        this.application.tick();
        //setTimeout(()=>{}, 0); //ApplicationRef.tick();
      });
    this.subscriptions.push(s1);
  }
  triggerStepChange: EventEmitter<void> = new EventEmitter<void>();


  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
  private domainStr: string;
  subscriptions: Subscription[] = [];

  private updatedRfpAccountid: number = 0;
  rfpAccountidUpdate(data: number) {
    this.updatedRfpAccountid = data;
  }

  _showSpinner: boolean = false;
  set showSpinner(enable: boolean) {
    this._showSpinner = enable;
  }
  get showSpinner() {
    return this._showSpinner;
  }
  isBusy(enable: boolean) {
    this.showSpinner = enable;
  }

  @ViewChild('userForm', { static: false }) userForm: NgForm;
  @ViewChild(AlertComponent, { static: false }) alerter: AlertComponent;
  @ViewChild('fileItem', { static: false }) fileItem: NgModel;
  @ViewChild(PropertyEditComponent, { static: true }) propertyEditComponent: PropertyEditComponent;
  @ViewChild(ProcessSettingsComponent, { static: true }) processSettingsComponent: ProcessSettingsComponent;
  @ViewChild(QaSelectCompanyComponent, { static: false }) selectCompanyComponent: QaSelectCompanyComponent;
  @ViewChild(QaEmailVerificationComponent, { static: false }) emailVerificationComponent: QaEmailVerificationComponent;

  step2: any = {
    showNext: true,
    showPrev: true
  };
  step1: any = {
    showNext: false,
    showPrev: false
  };
  step3: any = {
    showSecret: false,
    showNext: false,
    showPrev: true
  };
  myFiles: FileList = null;
  get stepOneDone(): boolean {
    if (!this.isQuickAudit) {
      return this.myFiles && this.myFiles.length > 0 && (this.importedData ? true : false) && this.importedData.property.length > 0 && this.step1.showNext;
    }
    else {
      if(!this.editedAudit.AuditAmadeus && !this.editedAudit.AuditApollo && !this.editedAudit.AuditGalileo
        && !this.editedAudit.AuditSabre && !this.editedAudit.AuditWorldspan ){
          return false;
        }
      var accountTypesForComparisonKeywords: Array<string> = ["Master", "Supply"];
      var user = this.userProfileService.data;
      if (accountTypesForComparisonKeywords.includes(user.CustomerType)) {
        return this.updatedRfpAccountid > 0;
      }
      return true;

    }
    return false;
  }


  onStepChanged(event) {
    console.log(event.title);
  }
  failStep1QuickAudit: boolean = false;

  async onStep1Next(event) {
    console.log('Step2 - Next');
    this.showSpinner = true;
    if (!this.isQuickAudit) {
      this.backupCopy.AuditAmadeus=this.editedAudit.AuditAmadeus;
      this.backupCopy.AuditApollo=this.editedAudit.AuditApollo;
      this.backupCopy.AuditSabre=this.editedAudit.AuditSabre;
      this.backupCopy.AuditGalileo=this.editedAudit.AuditGalileo;
      this.backupCopy.AuditWorldspan=this.editedAudit.AuditWorldspan;
      this.propertyEditComponent.editedAudit = AuditStdEdit.copy(this.backupCopy);
      this.propertyEditComponent.OnEnterFromNext();
    }
    else {
      event.okToProceed = false;
      event.waitForProceedEvent = true;
      this.failStep1QuickAudit = false;
      let errMsg = "";
      try {
        this.importedData = new AuditStdImport();
        errMsg = "Failed to load customer settings.";
        if (!this.isQuickAuditRerun) {
          var data: CustomerModel = await this.customersService.GetCustomer().toPromise();//.then( (qap) => {data = qap;});
          this.importedData.RACFilters = "";
          this.importedData.SabrePCC = data.SabreAAAPCC || "";
          this.importedData.AccountType = this.userProfileService.data.CustomerType == "Supply" ? "N" : "C";
          this.okayToExit = false;
        }

        errMsg = "Failed to read property data for the audit or failed validation for the request.";
        let yr = this.isQuickAuditRerun?0: this.selectCompanyComponent.selectedContractYear
        let acctID = this.isQuickAuditRerun?0: this.updatedRfpAccountid;
        this.step2.showPrev = this.isQuickAuditRerun?false:true;
        let trackingID = await this.raService.beginGetQAProperties(yr, acctID, this.quickAuditRerunID).toPromise();
        let qaProperties:qaPropertiesHeader = await this.raService
          .pollQAProperties(trackingID).toPromise();
        this.okayToExit = false;
        this.rerunInfo = qaProperties.rerun;
        if (qaProperties.properties == null
          || qaProperties.properties.length == 0) {
          this.confirmDlg("No properties available to audit", "", "Aborting", false);
          event.proceed.next(false);
        } else {
          this.propertyCountDescription = "Properties loaded:"
          this.propertyCount=qaProperties.properties.length;
          do {
            let moreQAProperties:qaPropertiesHeader  = await this.raService
              .pollQAProperties(trackingID).toPromise();
            if (moreQAProperties.properties==null ||moreQAProperties.properties.length==0 ) {
              break;
            }
            this.propertyCount+=moreQAProperties.properties.length;
            qaProperties.properties = qaProperties.properties.concat(moreQAProperties.properties);
            //if (qaProperties.properties.length>50) {
            //  break;
            //}
          } while (true);
          errMsg = "Failed to load and pre-process property data for audit.";
          this.sessionGuid = qaProperties.sessionGuid;
          this.importedData.set(qaProperties);
          this.importedData.AuditAmadeus=this.isQuickAuditRerun? this.importedData.AuditAmadeus: this.editedAudit.AuditAmadeus;
          this.importedData.AuditApollo=this.isQuickAuditRerun? this.importedData.AuditApollo : this.editedAudit.AuditApollo;
          this.importedData.AuditGalileo=this.isQuickAuditRerun? this.importedData.AuditGalileo : this.editedAudit.AuditGalileo;
          this.importedData.AuditSabre=this.isQuickAuditRerun? this.importedData.AuditSabre : this.editedAudit.AuditSabre;
          this.importedData.AuditWorldspan=this.isQuickAuditRerun? this.importedData.AuditWorldspan : this.editedAudit.AuditWorldspan;

          this.amadeusAvailable = this.isQuickAuditRerun?this.importedData.AuditAmadeus:this.amadeusAvailable;
          this.apolloAvailable = this.isQuickAuditRerun?this.importedData.AuditApollo:this.apolloAvailable;
          this.galileoAvailable = this.isQuickAuditRerun?this.importedData.AuditGalileo:this.galileoAvailable;
          this.sabreAvailable = this.isQuickAuditRerun?this.importedData.AuditSabre:this.sabreAvailable;
          this.worldspanAvailable = this.isQuickAuditRerun?this.importedData.AuditWorldspan:this.worldspanAvailable;

          this.editedAudit = new AuditStdEdit(this.importedData, true, this.userProfileService.data.Email);
          await this.fixupEditedAudit();
          this.propertyEditComponent.editedAudit = this.editedAudit;
          this.propertyEditComponent.OnEnterFromNext();
          event.proceed.next(!this.failStep1QuickAudit);
        }
      } catch (error) {
        console.log(error);
        this.confirmDlg("While acquiring data to perform the audit.", errMsg, "Error", false)
          .subscribe(() =>{
            if(this.isQuickAuditRerun){
              this.okayToExit = true;
              this.router.navigate(['/main/rateAudit/monitor']);
            }
              });
        event.proceed.next(false);
      }
    }
    this.showSpinner = false;
  }
  onStep2Prev(event) {
    if(this.isQuickAuditRerun){
      event.okToProceed = false;
      this.okayToExit = true;
      this.router.navigate(['/main/rateAudit/monitor']);
    }
  }

  onStep2Next(event) {
    event.okToProceed = this.propertyEditComponent.validateBeforeProceedingToNextStep();
    this.IdentifyNegotiatedRateAccesCode()
    this.processSettingsComponent.editedAudit = this.propertyEditComponent.editedAudit;
    console.log('Step2 - Next');
  }

  IdentifyNegotiatedRateAccesCode() {
    if (this.rerunInfo) {
      this.processSettingsComponent.racAmadeus = this.rerunInfo.AmadeusRAC;
      this.processSettingsComponent.racApollo = this.rerunInfo.ApolloRAC;
      this.processSettingsComponent.racGalileo = this.rerunInfo.GalileoRAC;
      this.processSettingsComponent.racSabre = this.rerunInfo.SabreRAC;
      this.processSettingsComponent.racWorldspan = this.rerunInfo.WorldspanRAC;
      return;
    }
    let d:number ;
    let am:Dictionary<string,number> = new Dictionary<string,number>();
    let ap:Dictionary<string,number> = new Dictionary<string,number>();
    let ga:Dictionary<string,number> = new Dictionary<string,number>();
    let sa:Dictionary<string,number> = new Dictionary<string,number>();
    let ws:Dictionary<string,number> = new Dictionary<string,number>();

    this.propertyEditComponent.editedAudit.property.forEach( p =>{
      this.Inc(am, p.AmadeusRateAccessCode);
      this.Inc(ap, p.ApolloRateAccessCode);
      this.Inc(ga, p.GalileoRateAccessCode);
      this.Inc(sa, p.SabreRateAccessCode);
      this.Inc(ws, p.WorldspanRateAccessCode);
    })
    this.processSettingsComponent.racAmadeus = this.GetMostFrequentlyUsed(am);
    this.processSettingsComponent.racApollo = this.GetMostFrequentlyUsed(ap);
    this.processSettingsComponent.racGalileo = this.GetMostFrequentlyUsed(ga);
    this.processSettingsComponent.racSabre = this.GetMostFrequentlyUsed(sa);
    this.processSettingsComponent.racWorldspan = this.GetMostFrequentlyUsed(ws);

  }

  Inc(d:Dictionary<string,number>,  rac:string){
    let cnt = d.getValue(rac);
    d.setValue(rac, cnt+1)
  }
  GetMostFrequentlyUsed(d:Dictionary<string,number>){
    if (d.count>0) {
      return d.toArray().sort((a,b)=> b.value - a.value)[0].key;
    }

  }
  onStep3Next(event) {
    if(!this.processSettingsComponent.validateBeforeCompleting()){
      event.okToProceed = false;
    }
    if (this.processSettingsComponent.validateEmail) {
      this.emailVerificationComponent.editedAudit = this.processSettingsComponent.editedAudit;
    }
    console.log('Step3 - Next');
  }

  onComplete(event) {
    event.okToProceed = false;
    let finalAudit;
    let emailsOkay;
    let okay = this.processSettingsComponent.validateBeforeCompleting();
    if (this.processSettingsComponent.validateEmail) {
      emailsOkay = this.emailVerificationComponent.validateBeforeCompleting();
      finalAudit = this.emailVerificationComponent.editedAudit;
      if (!emailsOkay) {
        return;
      }
    }
    else {
      emailsOkay = true;
      finalAudit = this.processSettingsComponent.editedAudit
    }
    let gdsList = (finalAudit.AuditAmadeus) ? "\t Amadeus \n" : "";
    gdsList += (finalAudit.AuditApollo) ? "\t Apollo \n" : "";
    gdsList += (finalAudit.AuditGalileo) ? "\t Galileo \n" : "";
    gdsList += (finalAudit.AuditSabre) ? "\t Sabre \n" : "";
    gdsList += (finalAudit.AuditWorldspan) ? "\t Worldspan \n" : "";

    if (okay && emailsOkay) {
      let finalAuditProperties : Array<Property> = finalAudit.property;
      this.processSettingsComponent.updateBeforeCompleting();
      let emailTemplateMessage:string = finalAudit.NotificationTemplateID?("Email Template: " + finalAudit.NotificationTemplateName + "\n"):"";
      this.confirmDlg("Are you ready to submit your Rate Audit?",
        "Hotel count to Audit: " + finalAuditProperties.map(item => {
          return {
            LoadedFromOriginal: item.LoadedFromOriginal
          };
        }).filter(item => !item.LoadedFromOriginal).length + "\n"
        + emailTemplateMessage
        + "GDS's to Audit: " + "\n" + gdsList
        + "Comparison Keywords: " + "\n \t" + finalAudit.RACFilters, "Confirmation", true)
        .subscribe(ok => {
          if (ok) {
            this.showSpinner = true;
            this.processSettingsComponent.SaveAudit()
              .subscribe(rtn => {
                this.showSpinner = false;
                if (rtn.success) {
                  event.okToProceed = false;
                  this.isCompleted = true;
                  this.okayToExit = true;
                  this.confirmDlg(rtn.message, "", "Success", false)
                    .subscribe(rtn => this.router.navigate(['/main/rateAudit/monitor']));
                  //'Job successfully loaded for processing, assigned Audit # '
                } else {
                  this.confirmDlg(rtn.message, "", "Error", false);
                }

              }, (err => {
                this.showSpinner = false;
                this.confirmDlg("Unexpected error saving new audit", "", "Error", false);
              }), () => this.showSpinner = false);
          }
        });
    }
  }
  isQuickAudit: boolean = false;
  isQuickAuditRerun: boolean = false;
  rerunInfo: qaRerunHeader = null;


  isCompleted: boolean = false;
  selectFileControl: AbstractControl = null;

  onFileSelected(event) {
    //clear out previous, if set
    this.onRemoveSelectedFile();

    if (!event.currentTarget || !event.currentTarget.files || event.currentTarget.files.length <= 0)
      return; //most likely the user canceled after a file had been selected

    this.isBusy(true);
    this.myFiles = event.currentTarget.files;
    this.file = event.currentTarget.files[0];
    this.selectFileControl = this.fileItem.control;
    console.log(this.myFiles);
    var arr = Array.from(this.myFiles);
    this.uploader.addFiles(arr);
  }
  file: any;

checkGDSCredentials(){
  this.customersService.getCustomersGDSCredentials().subscribe((gdsCredentials)=>{
    this.disableAuditAmadeus = (gdsCredentials && gdsCredentials.AmadeusActive) ? false : true;
    this.disableAuditApollo = (gdsCredentials && gdsCredentials.ApolloActive) ? false : true;
    this.disableAuditGalileo = (gdsCredentials && gdsCredentials.GalileoActive) ? false : true;
    this.disableAuditSabre = (gdsCredentials && gdsCredentials.SabreActive) ? false : true;
    this.disableAuditWorldspan = (gdsCredentials && gdsCredentials.WorldspanActive) ? false : true;
  })
}

  setupFineUploader() {
    const cors: CorsOptions = { expected: true, sendCredentials: true };
    const paramNames: ParamNamesOptions = {/*partIndex: 'SEQ'*/ };
    const chunking: ChunkingOptions = { concurrent: { enabled: false }, enabled: true, mandatory: false, partSize: 2000000, paramNames: paramNames };
    const request: RequestOptions = {
      inputName: 'filename', /*method: 'GET', paramsInBody: false, */
      endpoint: this.domainStr + 'Upload/UploadFile'
    } //?filename={0}&append={1}&SEQ={2}&Last={3}
    const callbacks: CoreEvents = {
      onError: (id: number, name: string, errorReason: string, xhr: XMLHttpRequest) => {
        console.log('onError ' + id); this.resetUploadControls();
        this.step1.showNext = false;
        if(errorReason.indexOf('invalid extension') > 0)
          this.showUploadError(errorReason)
        else if (errorReason != "No files to upload.")
          this.showUploadError("Error uploading file.")
      },
      onProgress: (id: number, name: string, uploadedBytes: number, totalBytes: number) => { console.log('onProgress ' + id); },
      onResume: (id: number, name: string, chunkData: any) => { console.log('onResume ' + id); },
      onUploadChunk: (id: number, name: string, chunkData: ChunkData) => { console.log('onUploadChunk ' + id); },
      onUploadChunkSuccess: (id: number, chunkData: ChunkData, responseJSON: any, xhr: XMLHttpRequest) => { console.log('onUploadChunkSuccess ' + id); },
      onStatusChange: (id: number, oldStatus: string, newStatus: string) => { console.log('onStatusChange ' + id); },
      onSubmit: (id: number, name: string) => { console.log('onSubmit ' + id); this.step1.showNext = false;},
      onSubmitted: (id: number, name: string) => { console.log('onSubmitted ' + id); },
      onUpload: (id: number, name: string) => { console.log('onUpload ' + id); },
      onComplete: (id: number, name: string, responseJSON: any, xhr: XMLHttpRequest) => {
        console.log('onComplete ' + id);
        if(responseJSON.success){
        this.selectedFileOnServer = responseJSON.uniqueFilename;
        this.sessionGuid = responseJSON.sessionGuid;
        const s1 = this.excelImportService.importExcelFile(responseJSON.uniqueFilename)
          .subscribe(
            async (data) => {
              if (data.delayedFile) {
                this.excelImportService.importExcelRetryDelayedFile(data.delayedFile)
                  .subscribe(
                    async (data2) => {
                      console.log("data2");
                      if (data2.delayError) {
                        this.showUploadError("Error while downloading results.");
                      } else {
                        await this.setUploadedData(name, data2.properties, this.file.size)
                      }
                    },
                    (err) => {
                      console.log("err2");
                      console.log(err);
                      if(err.status == 401){
                        this.userProfileService.TakeUserToLogoutPage();
                      } else {
                        this.showUploadError("Error dowloading upload results.");
                      }
                    }
                  );
              }
              else {
                await this.setUploadedData(name, data.properties, this.file.size)
              }
            },
            (err) => { console.log(err);
              if(err.status == 401){
                this.userProfileService.TakeUserToLogoutPage();
              }
              else{
               this.showUploadError("Error processing file after it was uploaded, verify file format.");
              }
            }
          );
          this.subscriptions.push(s1);
        }
        else
        {
          if(responseJSON.error != undefined && responseJSON.error.indexOf("file is corrupted") > 0){
            this.showUploadError(responseJSON.error);
          }
          else{
            this.showUploadError("Error uploading file");
          }
        }
      },
    };
    const options: CoreOptions = { autoUpload: true, debug: true, validation:{
      allowedExtensions: ['xls', 'xlsx']
    }, chunking: chunking, cors: cors, request: request, callbacks: callbacks };
    this.uploader = new FineUploaderBasic(options);

  }
  uploader: FineUploaderBasic;

  showUploadError(msg: string) {
    this.resetUploadControls();
    this.alerter.showAlertMessage(5000, msg, EnumAlertType.Error);
  }
  resetUploadControls() {
    this.isBusy(false);
    this.showGds=false;
  }

  initUploadStats: ImportResults = { TotalPropertyCount: "", CustomerID: "", PreviousAuditTitle: "", PreviousAuditID: "", MatchPropertyCount: "" };
  uploadStatistics: ImportResults = this.initUploadStats;
  async setUploadedData(filename: string, data: any, filesize) {
    this.resetUploadControls();
    data.property = data.property.length ? data.property : [data.property];
    this.okayToExit = false;
    this.selectedFileToUpload = filename;
    this.importedData = data;
    this.editedAudit = new AuditStdEdit(this.importedData, this.isQuickAudit, this.userProfileService.data.Email); //clone the data
    await this.fixupEditedAudit();
    this.backupCopy = AuditStdEdit.copy(this.editedAudit)
    this.processSettingsComponent.editedAudit = this.editedAudit;
    this.uploadStatistics = data.ImportResults;
    this.thisIsARerun = this.uploadStatistics.PreviousAuditID ? true : false;
    this.checkGDSCredentials();

    if (filesize > 1024) {
      var sizeStr = " KB";
      filesize = filesize / 1024;
      if (filesize > 1024) {
        filesize = filesize / 1024;
        sizeStr = " MB";
      }
      this.uploadFilesize = filesize.toFixed(2) + sizeStr;
    }
    this.step1.showNext = true;

  }

  async fixupEditedAudit() {
    const keywordManager = new KeywordManager();
    this.editedAudit.StoredFileName = this.isQuickAudit ? "" : this.selectedFileOnServer;
    this.editedAudit.sessionGuid = this.sessionGuid;
    if (this.editedAudit.SabrePCC && this.editedAudit.SabrePCC.length > 10) {
      this.editedAudit.SabrePCC = this.editedAudit.SabrePCC.substr(0, 10);
      this.alerter.showAlertMessage(8000, 'Truncated oversized SabrePCC "' + this.editedAudit.SabrePCC + '" to it\'s max length of 10. ', 1);
    }
    try {
      var data = await this.customersService.getCustomersGDSCredentials().toPromise();
      this.processSettingsComponent.gdsCredentials = data;
      this.gdsCredentials = data;
      this.editedAudit.AuditAmadeus = data.AmadeusActive ? this.editedAudit.AuditAmadeus : false;
      this.editedAudit.AuditApollo = data.ApolloActive ? this.editedAudit.AuditApollo : false;
      this.editedAudit.AuditGalileo = data.GalileoActive ? this.editedAudit.AuditGalileo : false;
      this.editedAudit.AuditSabre = data.SabreActive ? this.editedAudit.AuditSabre : false;
      this.editedAudit.AuditWorldspan = data.WorldspanActive ? this.editedAudit.AuditWorldspan : false;
      if (this.isQuickAudit) {
        if (!this.editedAudit.AuditAmadeus
          && !this.editedAudit.AuditApollo
          && !this.editedAudit.AuditGalileo
          && !this.editedAudit.AuditSabre
          && !this.editedAudit.AuditWorldspan && !this.isQuickAuditRerun) {
          this.failStep1QuickAudit = true;
          this.alerter.showAlertMessage(8000, "Did not find any GDS Credentials", 2);
          }

        else if(this.isQuickAuditRerun && !this.editedAudit.AuditAmadeus
          && !this.editedAudit.AuditApollo
          && !this.editedAudit.AuditGalileo
          && !this.editedAudit.AuditSabre
          && !this.editedAudit.AuditWorldspan ){
            this.failStep1QuickAudit = true;
            this.alerter.showAlertMessage(8000, "Did not find any GDS Credentials, please contact Support Team ", 2);
          }
        this.editedAudit.property.filter(r=> !r.LoadedFromOriginal).forEach(r => {
          r.ProcessAmadeus = this.editedAudit.AuditAmadeus;
          r.ProcessApollo = this.editedAudit.AuditApollo;
          r.ProcessGalileo = this.editedAudit.AuditGalileo;
          r.ProcessSabre = this.editedAudit.AuditSabre;
          r.ProcessWorldspan = this.editedAudit.AuditWorldspan;
        });
        this.editedAudit.QuickAuditChannelID= (this.updatedRfpAccountid)?this.updatedRfpAccountid:null;

      }

    } catch (error) {
      console.log(error)
      this.failStep1QuickAudit = true;
      this.alerter.showAlertMessage(8000, "Not able to get GDS Credentials", 2);
    }

    keywordManager.BreakdownList(this.editedAudit.RACFilters);
    if (!this.isQuickAudit && keywordManager.Keywords.length == 0) {
      const msg = this.editedAudit.RACFilters.trim().length > 0 ? "The text provided for Keyword filtration was not properly formatted.  It will be necessary to manually create keywords in the “Processing Settings” tab for this audit to process."
        : "No keywords were provided for this audit run.  It will be necessary to manually create keywords in the “Processing Settings” tab for this audit to process.";
      this.confirmDlg(msg, "", "Keyword Error")
        .subscribe(
          () => {

          });

    }
    //    this.editedAudit.RACFilters = keywordManager.GetCommaList();
    this.raService.GetNotificationTemplate()
      .subscribe(data => {
        this.processSettingsComponent.notificationTemplateList = data.map(d => { return { id: d.NotificationTemplateID, name: d.Name, isDefault: d.isDefault }; });
      })

    const type = this.editedAudit.AccountType.trim().toUpperCase();
    let allowedTypes = ['C', 'N', 'X'];
    this.editedAudit.AccountType = ((!type || type == "" || !(allowedTypes.includes(type))) ? "C" : type);

    this.editedAudit.property.forEach(property => {
      if(!property.LoadedFromOriginal){
        property.InitializeAfterUpload();
      }else{
        property.SaveOriginalSeasonsInfo();
      }
    });

    try {
      let rangeRules: AuditStd_DateRangeRules = await this.rateAuditSettingsService.Get().toPromise();
      this.propertyEditComponent.setOriginalDateSelectionRule(rangeRules);
    } catch (error) {
      console.log(error)
      this.propertyEditComponent.setOriginalDateSelectionRule(defaultAuditStd_DateRangeRules() );
    }

    this.defaultsService.getLookupCurrencyCodes()
      .subscribe((data) => {
        this.propertyEditComponent.currencyCodes = data;
      });
  }

  Alert(msg: string) {
    console.log(msg)
  }

  selectedFileToUpload = "";
  selectedFileOnServer = "";
  sessionGuid = "";
  importedData: AuditStdImport;  //don't edit
  backupCopy: AuditStdEdit;
  editedAudit: AuditStdEdit;   //use this for edit
  uploadFilesize: string;
  thisIsARerun: boolean = false;
  onRemoveSelectedFile() {
    this.selectedFileToUpload = "";
    this.selectedFileOnServer = "";
    this.sessionGuid = "";
    this.thisIsARerun = false;
    this.uploadStatistics = this.initUploadStats;
    this.myFiles = null;
    this.importedData = new AuditStdImport();
    this.editedAudit = new AuditStdEdit(this.importedData, this.isQuickAudit, this.userProfileService.data.Email);
    this.step1.showNext = false;
  }
  okayToExit: boolean = true;
  canDeactivate(): Observable<boolean> | boolean {
    // Allow synchronous navigation (`true`) if no crisis or the crisis is unchanged
    ;
    if (this.okayToExit == true)
      return true;
    // Otherwise ask the user with the dialog service and return its
    // promise which resolves to true or false when the user decides
    let answerObservable = this.confirmDlg("Are you sure you wish to cancel editing this audit?"
      , "Any unsaved changes will be lost.", "Confirmation", true);
    return answerObservable;
  }
  onDeactivateDone: Subject<boolean> = null;
  openModal: boolean = false;
  dialogTitle: string = "";
  dialogTextLine1: string = "";
  dialogTextLine2: string = '';
  cancelButton: string = null;
  onDialogDone: Subject<boolean> = null;
  okCloseButtonClick(ok: boolean) {
    if (this.onDialogDone) {
      this.openModal = false;
      this.onDialogDone.next(ok);
    }
  }
  confirmDlg(msg: string, msg2: string, title: string, cancelButton: boolean = false): Observable<boolean> {
    this.dialogTitle = title;
    this.dialogTextLine1 = msg;
    this.dialogTextLine2 = msg2;
    this.openModal = true;
    this.onDialogDone = new Subject<boolean>();

    this.cancelButton = cancelButton ? "Cancel" : null;
    return this.onDialogDone.asObservable();
  }
  enableStep4:boolean = false;
  ShowNextOrSubmit(event) {
    this.step3.showNext = event;
    this.enableStep4 = event;

  }
}
